import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AddCompetition from "./components/AddCompetition";
import Competitions from "./components/Competitions";
import MulticityHome from "./components/MulticityHome";
import CityPage from "./components/CityPage";
import CompiPage from "./components/CompiPage";
import MainCompiPage from "./components/mainFest/MainCompiPage";
import CompiParameters from "./components/CompiParameters";
import Parameters from "./components/Parameters";
import JudgeHome from "./components/judge/JudgeHome";

import JudgeCityPage from "./components/judge/JudgeCityPage";
import JudgeCompiPage from "./components/judge/JudgeCompiPage";
import ManualSlotting from "./components/ManualSlotting";
import Navbar from "./components/Navbar";
import AdminLogin from "./components/AdminLogin";
import JudgeLogin from "./components/judge/JudgeLogin";
import ScoreSheet from "./components/ScoreSheet";
import AddMainCompi from "./components/AddMainCompi";
import AdminHome from "./components/AdminHome";
import AddMulJudge from "./components/AddMulJudge";
import MulJudges from "./components/MulJudges";
import AddUser from "./components/AddUser";
import PornitesHome from "./components/pronites/PornitesHome";
import LiveWire from "./components/pronites/LiveWire";
import SoulStrings from "./components/pronites/SoulStrings";
import MainFestSlotting from "./components/mainFest/MainFestSlotting";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Competitions />} />
          {/* ===================== ADMIN ROUTES ===================== */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/add_user" element={<AddUser />} />
          <Route path="/admin/addcompi" element={<AddMainCompi />} />
          <Route
            exact
            path="/admin/multicity/addcompi"
            element={<AddCompetition />}
          />
          <Route path="/admin/parameters" element={<CompiParameters />} />
          <Route path="/admin/parameters/:compName" element={<Parameters />} />
          <Route
            path="/admin/multicity/slotting/:id"
            element={<ManualSlotting />}
          />
          <Route path="/admin/multicity" element={<MulticityHome />} />
          <Route
            path="/admin/multicity/parameters"
            element={<CompiParameters />}
          />
          <Route path="/admin/multicity/:city" element={<CityPage />} />
          <Route path="/admin/multicity/judges" element={<MulJudges />} />
          <Route path="/admin/multicity/add_judge" element={<AddMulJudge />} />
          <Route
            path="/admin/multicity/competition/:compId"
            element={<CompiPage />}
          />
          <Route
            path="/admin/mul/compi_score/:compId"
            element={<ScoreSheet />}
          />
          <Route path="/admin/competitions" element={<AdminHome />} />
          <Route
            path="/admin/competitions/competition/:compId"
            element={<MainCompiPage />}
          />
          <Route
            path="/admin/competitions/slotting/:id"
            element={<MainFestSlotting />}
          />
          <Route path="/admin/pronites" element={<PornitesHome />} />
          <Route path="/admin/pronites/livewire" element={<LiveWire />} />
          <Route path="/admin/pronites/soulstrings" element={<SoulStrings />} />

          {/* ======================= JUDGE ROUTES ================== */}
          <Route path="/judge/login" element={<JudgeLogin />} />
          <Route path="/judge/multicity" element={<JudgeHome />} />
          <Route path="/judge/multicity/:city" element={<JudgeCityPage />} />
          <Route
            path="/judge/multicity/competition/:compId"
            element={<JudgeCompiPage />}
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
